<script setup>
import { computed } from 'vue';
import { Radar } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
} from 'chart.js';

const props = defineProps({
  collection: {
    type: Object,
    default: () => ({}),
  },
  chartOptions: {
    type: Object,
    default: () => ({}),
  },
});

ChartJS.register(
  Title,
  Tooltip,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler
);

const fontFamily =
  'Inter,-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';

const defaultChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
      labels: {
        fontFamily,
      },
    },
    tooltip: {
      callbacks: {
        label(context) {
          return `${context.label}: ${context.formattedValue}`;
        },
      },
    },
  },
  animation: {
    duration: 0,
  },
  scales: {
    r: {
      min: 0,
      max: 100,
      beginAtZero: true,
      ticks: {
        stepSize: 25,
        font: { family: fontFamily, size: 10 },
        backdropColor: 'transparent',
        color: '#8B949E',
      },
      grid: {
        color: 'rgba(139, 148, 158, 0.2)',
      },
      angleLines: {
        color: 'rgba(139, 148, 158, 0.2)',
      },
      pointLabels: {
        font: { family: fontFamily, size: 12 },
        color: '#57606A',
      },
    },
  },
};

const options = computed(() => ({
  ...defaultChartOptions,
  ...props.chartOptions,
  scales: {
    r: {
      ...defaultChartOptions.scales.r,
      ...(props.chartOptions.scales?.r || {}),
      pointLabels: {
        ...defaultChartOptions.scales.r.pointLabels,
        ...(props.chartOptions.scales?.r?.pointLabels || {}),
      },
    },
  },
  plugins: {
    ...defaultChartOptions.plugins,
    ...(props.chartOptions.plugins || {}),
  },
}));
</script>

<template>
  <div class="h-full">
    <Radar :data="collection" :options="options" />
  </div>
</template>
